import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const markBoundaryCursorPluginKey = new PluginKey('markBoundaryCursorPlugin');
